import React from "react";
import Router from "../Router/Router";
import "./App.css";
import firebase from "firebase/app";

var App = function App(props) {
  document.title = props.profileConfig.title;
  firebase.initializeApp(props.firebaseConfig);
  return /*#__PURE__*/React.createElement(Router, {
    history: props.history,
    firebaseConfig: props.firebaseConfig,
    pagesConfig: props.pagesConfig,
    profileConfig: props.profileConfig,
    reportsConfig: props.reportsConfig,
    replaceReducer: props.replaceReducer
  });
};

export default App;